import { useEffect } from "react";

import { setLocalStoragePopupPrevented } from "./helpers";

export default function useChatPanelEvents(
  chatPanel: BoostChatPanel | null,
  setIsChatPanelOpen: (value: boolean) => void
) {
  useEffect(() => {
    if (!chatPanel) return;

    // When chat panel closed, prevent automatic popping up when page changed
    const handleChatPanelClosed = () => {
      setLocalStoragePopupPrevented(true);
      setIsChatPanelOpen(false);
    };

    // When chat panel minimized, prevent automatic popping up when page changed
    const handleChatPanelMinimised = () => {
      setLocalStoragePopupPrevented(true);
      setIsChatPanelOpen(false);
    };

    chatPanel.addEventListener("chatPanelClosed", handleChatPanelClosed);
    chatPanel.addEventListener("chatPanelMinimized", handleChatPanelMinimised);

    return () => {
      chatPanel.removeEventListener("chatPanelClosed", handleChatPanelClosed);
      chatPanel.removeEventListener(
        "chatPanelMinimized",
        handleChatPanelMinimised
      );
    };
  }, [chatPanel, setIsChatPanelOpen]);
}
